export default __webpack_public_path__ + "static/media/9.a3d8ee4c.jpg";